import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getTranslations = async (appId: string, widget?: string) => {
  const { data } = await IBModuleApi.get(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/translations?appId=${appId}${!!widget ? '&widget='+widget : ''}`
  );

  return data;
};

export const createTranslation = async (createInfo: any, appId: string) => {
  const { data } = await IBModuleApi.post(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/translations?appId=${appId}`,
    createInfo
  );

  return data;
};

export const updateTranslation = async (updateInfo: any, appId: string) => {
  const { data } = await IBModuleApi.put(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/translations?appId=${appId}`,
    updateInfo
  );

  return data;
};

export const deleteTranslation = async (translationId: number) => {
  const { data } = await IBModuleApi.delete(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/translations/${translationId}`
  );

  return data;
};

export const exportTranslations = async (info: any) => {
  const { appid, filtersInfo, filename } = info;
  const { data } = await IBModuleApi.post(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/translations/export?appId=${appid}`,
    filtersInfo,
    {
      responseType: "blob",
    }
  );

  const href = URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = href;
  link.setAttribute("download", `${filename}.csv`);
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};

export const importTranslations = async (info: any) => {
  const { applicationid, importInfo } = info;
  const { data } = await IBModuleApi.post(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/translations/import?appId=${applicationid}`,
    importInfo
  );

  return data;
};

export const validateLabel = async (appId: string, key?: string) => {
  const { data } = await IBModuleApi.get(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/translations?appId=${appId}&key=${key}`
  );

  return data;
};